export const BREAKPOINTS = {
	XS: 320,
	SM: 425,
	MD: 768,
	LG: 1024,
	XL: 1440,
	XXL: 1600,
	mobile: 0,
	tablet: 912,
	laptop: 1248,
};

/**
 * @deprecated Use BREAKPOINTS instead
 */
export const BOOTSTRAP_BREAKPOINTS = {
	XS: 0,
	SM: 576,
	MD: 768,
	LG: 992,
	XL: 1248,
	XXL: 1400,
};

BREAKPOINTS.mobile = BREAKPOINTS.SM;

export const media = {
	gt: (key: keyof typeof BREAKPOINTS): string => `(min-width: ${BREAKPOINTS[key] + 1}px)`,
	lte: (key: keyof typeof BREAKPOINTS): string => `(max-width: ${BREAKPOINTS[key]}px)`,
};
